export default __webpack_public_path__ + "static/media/mobileapp.0670e9a2.png";